import React, { FC, PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'
import styles from './ItemTable.module.css'
import FeedLoadingState from '@/components/feed-loading-state'

const ItemTable: FC<
	PropsWithChildren<{
		className?: string
		columns: { label: string }[]
		headerClassName?: string
		columnClassName?: string
		isLoading?: boolean
	}>
> = (props): ReactElement => {
	const { columns, headerClassName, columnClassName } = props

	const renderColumnHeader = React.useCallback(
		({ label }: { label: string }, i: number) => (
			<div
				key={i}
				className={classNames({ [props.columnClassName ?? '']: !!columnClassName }, styles.columnHead)}
			>
				{label}
			</div>
		),
		[columnClassName, props.columnClassName]
	)

	return (
		<div className={classNames({ [props?.className ?? '']: !!props.className }, styles.root)}>
			<div
				className={classNames(
					{ [props.headerClassName ?? '']: !!headerClassName },
					styles[`columns-${columns?.length}`],
					styles.head
				)}
			>
				{columns.map(renderColumnHeader)}
			</div>
			{props?.isLoading ? <FeedLoadingState /> : props.children}
		</div>
	)
}

export default ItemTable
